import { render, staticRenderFns } from "./BaseComment.vue?vue&type=template&id=262d3d1e&"
import script from "./BaseComment.vue?vue&type=script&lang=js&"
export * from "./BaseComment.vue?vue&type=script&lang=js&"
import style0 from "./BaseComment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports